import { render, staticRenderFns } from "./do_not_sell.vue?vue&type=template&id=28fa826f&scoped=true"
import script from "./do_not_sell.vue?vue&type=script&lang=js"
export * from "./do_not_sell.vue?vue&type=script&lang=js"
import style0 from "./do_not_sell.vue?vue&type=style&index=0&id=28fa826f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa826f",
  null
  
)

export default component.exports